'use es6';

import get from 'transmute/get';
export var getDisablePrefill = get('disablePrefill');